import { Link } from 'gatsby';
import React from 'react';
import { Column, Container, Row } from '../../../../components/Grid';
import Icon from '../../../../components/Icon';
import Layout from '../../../../components/Layout';
import MultiVideoPlayer from '../../../../components/MultiVideoPlayer';
import Section from '../../../../components/Section';

const FinalistPresentations2025 = () => (
  <Layout
    title="3M 2025 YSC Finalist Presentations"
    className="annual-challenge has-video"
  >
    {/* Intro Title and Video */}
    <Section>
      <Container>
        {/* Breadcrumbs */}
        <ul className="breadcrumbs no-hero">
          <li className="breadcrumb">
            <Link to="/annual-challenge/about-the-challenge">
              Annual Challenge
            </Link>
          </li>
          <li className="breadcrumb">
            <Link to="/annual-challenge/event-gallery-videos">
              Inside the Challenge
            </Link>
          </li>
          <li className="breadcrumb">
            <Link to="/annual-challenge/event-gallery-videos">Videos</Link>
          </li>
          <li className="breadcrumb active">
            3M 2025 YSC Finalist Presentations
          </li>
        </ul>
        <Row>
          <Column size={10} offset={1} className="no-hero">
            <h1 className="page-title">3M 2025 YSC Finalist Presentations</h1>
            {/* Video Container */}
            <div className="video-container__with-pager multivideo">
              <MultiVideoPlayer
                videos={[
                  {
                    guidSrc: '9f463cf0-92de-4a2d-8aa7-917b16346fc5',
                    poster: '2025-finalist-thumb-Amaira-presentation.png',
                    title: '3M 2025 YSC Finalist: Amaira Srivastava',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: 'f2092e71-3e33-4109-bb2e-0c8e365d7e94',
                    poster: '2025-finalist-thumb-Aniket-presentation.png',
                    title: '3M 2025 YSC Finalist: Aniket Sarkar',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: '5c5703c6-6518-4125-b10c-b9e7448af0c5',
                    poster: '2025-finalist-thumb-Anirudh-presentation.png',
                    title: '3M 2025 YSC Finalist: Anirudh Rao',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: 'cfeed6f6-2d68-46a1-ae41-9c8a97f1c27a',
                    poster: '2025-finalist-thumb-Divyam-presentation.png',
                    title: '3M 2025 YSC Finalist: Divyam Desai',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: 'ae5148cf-9a68-488f-b8c7-7494ba435d1a',
                    poster: '2025-finalist-thumb-Isha-presentation.png',
                    title: '3M 2025 YSC Finalist: Isha Marla',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: 'e86d82dc-a3bb-4ca1-a2da-6c49e631c986',
                    poster: '2025-finalist-thumb-Kevin-presentation.png',
                    title: '3M 2025 YSC Finalist: Kevin Tang',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: 'd7df36ca-10a0-4b4b-a0e5-07230fe3b52d',
                    poster: '2025-finalist-thumb-Kiyara-presentation.png',
                    title: '3M 2025 YSC Finalist: Kiyara Gunawardena',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: 'a5d3d5c9-6f2f-44f0-a52a-dd3ec33d7fbb',
                    poster: '2025-finalist-thumb-Reanna-presentation.png',
                    title: '3M 2025 YSC Finalist: Reanna Patel',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: 'ae0b85f4-a45e-4441-890b-f23a2632ef40',
                    poster: '2025-finalist-thumb-Sheyna-presentation.png',
                    title: '3M 2025 YSC Finalist: Sheyna Patel',
                    description: '',
                    className: 'de-vid',
                  },
                  {
                    guidSrc: '3573689c-350d-4354-9163-9779f08bfaa6',
                    poster: '2025-finalist-thumb-Shrey-presentation.png',
                    title: '3M 2025 YSC Finalist: Shrey Arora',
                    description: '',
                    className: 'de-vid',
                  },
                ]}
              />
              <Link to="../3M-2020-YSC-Finalist-Presentations" className="next">
                <Icon name="arrowrightgray" />
              </Link>
            </div>
            <p className="text-26">
              Hear from the <strong>2025 Top Young Scientist Finalists</strong>{' '}
              as each presents their entry idea for the Annual Young Scientist
              Challenge.
            </p>
          </Column>
        </Row>
      </Container>
    </Section>
  </Layout>
);

export default FinalistPresentations2025;
